import { memo } from "react";
import { ownerData } from "../../data/main.data";
import ProfileImageSwitch from "./subComponents/ProfileImageSwitch";
import Lottie from "lottie-react";
import scrollDown from "../../lotties/scrollDown.json";

function Head() {
  return (
      <div className="bg-white px-3 py-7 w-full h-full md:max-h-screen flex justify-between items-center font-boska">
        <div className="w-full flex flex-col">
          <h1 className="text-6xl md:text-[9rem] md:leading-[9rem] font-black text-black">
            {ownerData.name}
          </h1>
          <p className="text-xl md:text-3xl font-light text-gray-700 pl-1">
            {ownerData.role}
          </p>
          <Lottie animationData={scrollDown} loop={true} className="pt-5 w-28 h-28 hidden md:flex" />
        </div>

        <div className="w-full h-full">
          <ProfileImageSwitch />
        </div>
      </div>
  );
}

export default memo(Head);
